import request from '@/utils/request'

function unwrap(promise, fallbackMessage) {
  return promise.then(response => {
    const res = response.data
    if (res.code === 0) return res
    throw new Error(res.msg || fallbackMessage)
  })
}

function stripSecretRef(rows) {
  if (!Array.isArray(rows)) return rows
  return rows.map(row => {
    if (row && typeof row === 'object') {
      const rest = { ...row }
      delete rest.secretRef
      return rest
    }
    return row
  })
}

/** 运营跨小区：仅显式传入 communityId 时带筛选，不自动注入当前物业小区 */
function withOptionalCommunity(params = {}) {
  const data = { ...params }
  if (!data.communityId) {
    delete data.communityId
  }
  return data
}

// ==================== 合作账号 ====================

export function listAccounts(params) {
  return unwrap(request({
    url: '/homeservice.listAccounts',
    method: 'post',
    data: params
  }), '获取合作账号列表失败').then(res => ({
    ...res,
    data: stripSecretRef(res.data)
  }))
}

export function saveAccount(data) {
  return unwrap(request({
    url: '/homeservice.saveAccount',
    method: 'post',
    data
  }), '保存合作账号失败')
}

export function updateAccount(data) {
  return unwrap(request({
    url: '/homeservice.updateAccount',
    method: 'post',
    data
  }), '更新合作账号失败')
}

export function deleteAccount(data) {
  return unwrap(request({
    url: '/homeservice.deleteAccount',
    method: 'post',
    data
  }), '删除合作账号失败')
}

// ==================== 城市映射 ====================

export function listCityMaps(params) {
  return unwrap(request({
    url: '/homeservice.listCityMaps',
    method: 'post',
    data: withOptionalCommunity(params)
  }), '获取城市映射列表失败')
}

export function saveCityMap(data) {
  return unwrap(request({
    url: '/homeservice.saveCityMap',
    method: 'post',
    data: withOptionalCommunity(data)
  }), '保存城市映射失败')
}

export function updateCityMap(data) {
  return unwrap(request({
    url: '/homeservice.updateCityMap',
    method: 'post',
    data
  }), '更新城市映射失败')
}

export function deleteCityMap(data) {
  return unwrap(request({
    url: '/homeservice.deleteCityMap',
    method: 'post',
    data
  }), '删除城市映射失败')
}

// ==================== 上门产品 ====================

export function listProducts(params) {
  return unwrap(request({
    url: '/homeservice.listProducts',
    method: 'post',
    data: params
  }), '获取产品列表失败')
}

export function saveProduct(data) {
  return unwrap(request({
    url: '/homeservice.saveProduct',
    method: 'post',
    data
  }), '保存产品失败')
}

export function updateProduct(data) {
  return unwrap(request({
    url: '/homeservice.updateProduct',
    method: 'post',
    data
  }), '更新产品失败')
}

export function deleteProduct(data) {
  return unwrap(request({
    url: '/homeservice.deleteProduct',
    method: 'post',
    data
  }), '删除产品失败')
}

// ==================== 产品发布 ====================

export function listPublications(params) {
  return unwrap(request({
    url: '/homeservice.listPublications',
    method: 'post',
    data: withOptionalCommunity(params)
  }), '获取发布列表失败')
}

export function savePublication(data) {
  return unwrap(request({
    url: '/homeservice.savePublication',
    method: 'post',
    data: withOptionalCommunity(data)
  }), '保存发布失败')
}

export function updatePublication(data) {
  return unwrap(request({
    url: '/homeservice.updatePublication',
    method: 'post',
    data
  }), '更新发布失败')
}

export function deletePublication(data) {
  return unwrap(request({
    url: '/homeservice.deletePublication',
    method: 'post',
    data
  }), '删除发布失败')
}

// ==================== 履约订单（只读 + 补推） ====================

export function listOrders(params) {
  return unwrap(request({
    url: '/homeservice.listOrders',
    method: 'post',
    data: withOptionalCommunity(params)
  }), '获取上门订单列表失败')
}

export function getOrder(params) {
  return unwrap(request({
    url: '/homeservice.getOrder',
    method: 'post',
    data: withOptionalCommunity(params)
  }), '获取上门订单详情失败')
}

export function retrySyncOrder(params) {
  return unwrap(request({
    url: '/homeservice.retrySyncOrder',
    method: 'post',
    data: withOptionalCommunity(params)
  }), '补推同步失败')
}
